module.exports = __webpack_public_path__ + "img/symbol_8.8a401612.png";